import { useMutation } from 'react-query';
import axios from 'axios';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';

export const usePostTerminalTicketPicture = () => {
  const context = useContext(AlertContext);

  const { mutate: uploadTerminalTicketPicture, isLoading: isUploadTerminalTicketPictureLoading } =
    useMutation(
      ['TerminalAppearanceUploadTicketPicture'],
      (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(TerminalAppearanceAPI.uploadTicketPicture, formData, multipartHeaders());
      },
      {
        onSuccess: () => {
          queryClient
            .invalidateQueries('TerminalAppearance')
            .then(() =>
              context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage })
            );
        }
      }
    );

  return { uploadTerminalTicketPicture, isUploadTerminalTicketPictureLoading };
};
